export default __webpack_public_path__ + "static/media/home_biens_vendus.f96bb673.png";